import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ld-push-notification-modal',
  imports: [MatProgressSpinnerModule, TranslocoDirective],
  templateUrl: './push-notification-modal.component.html',
  styleUrl: './push-notification-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PushNotificationModalComponent {
  isLoading = input<boolean>(false);

  allow = output<void>();

  skip = output<void>();

  protected onAllow(): void {
    if (!this.isLoading()) {
      this.allow.emit();
    }
  }

  protected onSkip(): void {
    if (!this.isLoading()) {
      this.skip.emit();
    }
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget && !this.isLoading()) {
      this.skip.emit();
    }
  }
}
